/**
 * @fileoverview ヘッダー部分のコンポーネント
 */
import { useTranslation } from "react-i18next";
/**
 * ヘッダー
 * @returns {JSX.Element} ヘッダーのJSX要素
 */
export function Header(): JSX.Element {
  const { t } = useTranslation();

  return (
    <header>
      <div className="p-header">
        <div className="p-header__top">
          <div className="p-header__inner">
            <p className="p-header__discriptiion">
              {t("あらゆる気体の測定に 株式会社ガステック")}
            </p>
          </div>
        </div>
        <div className="p-header__inner">
          <div className="p-header__logo">
            <a
              href="http://www.gastec.co.jp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={"/asset/img/common/lgo_gst.png"}
                alt={t("株式会社ガステック")}
              ></img>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
